import { render, staticRenderFns } from "./InfoComponent.vue?vue&type=template&id=05107b0e&scoped=true"
import script from "./InfoComponent.vue?vue&type=script&lang=js"
export * from "./InfoComponent.vue?vue&type=script&lang=js"
import style0 from "./InfoComponent.vue?vue&type=style&index=0&id=05107b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05107b0e",
  null
  
)

export default component.exports